/* Version: 3.5.137 */
'use client';
/**
 * Returns the id of the default tab when the component is first rendered
 * @param {array} tabs - list of all tab items
 * @param {string} selectedTab - id of the tab to be selected
 * @returns {string}
 */
var getDefaultTab = function getDefaultTab(tabs, selectedTab) {
  if (!tabs.length) {
    return null;
  }
  var selected = tabs.find(function (_ref) {
    var value = _ref.value,
      disabled = _ref.disabled;
    return value === selectedTab && !disabled;
  });
  var defaultTab = tabs.find(function (_ref2) {
    var disabled = _ref2.disabled;
    return !disabled;
  });
  if (!selected && !defaultTab) {
    // NOTE: only happens if all tabs are disabled
    return null;
  }
  var selectedValue = selected ? selected.value : defaultTab.value;
  return selectedValue;
};

export { getDefaultTab as default, getDefaultTab };
